import { useQuery } from '@tanstack/react-query';
import FarmService from '../services/FarmService';
import { FARMS_QUERY_KEY } from '../constants/Constant';
import { QUERY_STALE_TIME_MS } from 'constants/appConstants';
import useFetchUserProfile from './useFetchUserProfile';
import useFetchOrganisations from './useFetchOrganisations';

/**
 * Custom hook to fetch farms by organization ID
 *
 * Returns excluded farms and paddocks too. Views that display farm, paddock
 * or plan data must read `useVisibleOrgData` instead, which hides them.
 * @param orgId - The organization ID to fetch farms for
 * @returns Query object containing farms data, loading state, and error
 */
export const useFetchFarmsByOrgId = (orgId: string | null) => {
  const { data: userData, isError: isUserDataError } = useFetchUserProfile();
  const { data: organisationsData, isError: isOrganisationsError } =
    useFetchOrganisations();

  return useQuery({
    queryKey: [FARMS_QUERY_KEY, orgId],
    queryFn: () => {
      if (!orgId) return [];
      return FarmService.GetByOrgActive(orgId);
    },
    enabled:
      !!orgId &&
      !!userData &&
      !isUserDataError &&
      !isOrganisationsError &&
      !!organisationsData,
    staleTime: QUERY_STALE_TIME_MS,
  });
};
